































































































import Vue, { PropType } from 'vue';
import { mapActions } from 'vuex';
import { ALForm } from '@/common/component.types';

import { IQuote, IQuoteClassification, QuoteClassification } from '@/models';
import { ErrorManager } from '@/models/error';

import ErrorAlert from '../common/ErrorAlert.vue';

export interface Options extends InstanceType<typeof Vue> {
  $refs: {
    form: ALForm;
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  name: 'QuoteClassificationDrawerListItem',

  components: { ErrorAlert },

  props: {
    quote: Object as PropType<IQuote>
  },

  data() {
    return {
      menu: false,
      loading: false,
      isFormValid: false,
      errorMessage: '',
      detailErrorMessage: '',

      classification: this.quote.classification
    };
  },

  computed: {
    classificationsList(): IQuoteClassification[] {
      return QuoteClassification.getClassificationList();
    }
  },

  watch: {
    'quote.classification': {
      handler(value: number) {
        this.classification = value;
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions({
      setClassification: 'quote/setClassification'
    }),

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    validateForm(): boolean {
      let valid = false;
      if (this.$refs.form) {
        valid = this.$refs.form.validate();
      }
      return valid;
    },

    close() {
      this.menu = false;
    },

    applyQuoteClassification(classification: number) {
      if (this.validateForm()) {
        this.clearAllErrors();
        this.loading = true;

        this.setClassification({
          id: this.quote.number,
          classification: classification
        })
          .then(() => {
            (this.$refs.classification as any).save(classification);
            this.classification = classification;

            this.$emit('change');
            this.close();
          })
          .catch(error => {
            if (error.response) {
              // client received an error response that falls out of range 2xx
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }

            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
});
